import type { CardSettings } from 'cards/types/cardSettings';
import { CARD_TYPE_MAP } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';
import { URL_SLUG_BY_CARD_TYPE } from '@zola/zola-ui/src/paper/cards/constants/urlSlugByCardType';
import { LABEL_BY_CARD_TYPE } from '@zola/zola-ui/src/paper/cards/constants/labelByCardType';
import { SupportedLeadCardType } from 'cards/types/supportedLeadCardTypes';
import { HAS_MOTIFS_BY_CARD_TYPE } from './hasMotifsByCardType';

export const SETTINGS_BY_CARD_TYPE: Record<SupportedLeadCardType, CardSettings> = {
  MATCHING_SUITES: {
    type: 'MATCHING_SUITES',
    urlSlug: URL_SLUG_BY_CARD_TYPE.MATCHING_SUITES,
    label: LABEL_BY_CARD_TYPE.MATCHING_SUITES,
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE.MATCHING_SUITES,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.invitation]: {
    type: CARD_TYPE_MAP.invitation,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.invitation],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.invitation],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.invitation],
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: true,
  },
  [CARD_TYPE_MAP.std]: {
    type: CARD_TYPE_MAP.std,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.std],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.std],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.std],
    hasShapes: true,
    hasMagnet: true,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: true,
  },
  [CARD_TYPE_MAP.dstd]: {
    type: CARD_TYPE_MAP.dstd,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.dstd],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.dstd],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.dstd],
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.ctd]: {
    type: CARD_TYPE_MAP.ctd,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.ctd],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.ctd],
    hasFoil: false,
    hasLetterpress: true,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.ctd],
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.thankyou]: {
    type: CARD_TYPE_MAP.thankyou,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.thankyou],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.thankyou],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.thankyou],
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.menu]: {
    type: CARD_TYPE_MAP.menu,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.menu],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.menu],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.menu],
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.program]: {
    type: CARD_TYPE_MAP.program,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.program],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.program],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.program],
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.napkin]: {
    type: CARD_TYPE_MAP.napkin,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.napkin],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.napkin],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.napkin],
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.signage]: {
    type: CARD_TYPE_MAP.signage,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.signage],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.signage],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.signage],
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.sticker]: {
    type: CARD_TYPE_MAP.sticker,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.sticker],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.sticker],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.sticker],
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.place]: {
    type: CARD_TYPE_MAP.place,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.place],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.place],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.place],
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
  },
  DETAILS: {
    type: 'DETAILS',
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.enclosure],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.enclosure],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE.DETAILS,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.enclosure]: {
    type: CARD_TYPE_MAP.enclosure,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.enclosure],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.enclosure],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.enclosure],
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.holiday]: {
    type: CARD_TYPE_MAP.holiday,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.holiday],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.holiday],
    hasFoil: true,
    hasLetterpress: false,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.holiday],
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.weddingShower]: {
    type: CARD_TYPE_MAP.weddingShower,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.weddingShower],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.weddingShower],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.weddingShower],
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.tableNumber]: {
    type: CARD_TYPE_MAP.tableNumber,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.tableNumber],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.tableNumber],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.tableNumber],
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.paperAddOns]: {
    type: CARD_TYPE_MAP.paperAddOns,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.paperAddOns],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.paperAddOns],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.paperAddOns],
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.bellyBand]: {
    type: CARD_TYPE_MAP.bellyBand,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.bellyBand],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.bellyBand],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.bellyBand],
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.vellumJacket]: {
    type: CARD_TYPE_MAP.vellumJacket,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.vellumJacket],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.vellumJacket],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.vellumJacket],
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
  },
  [CARD_TYPE_MAP.waxSeal]: {
    type: CARD_TYPE_MAP.waxSeal,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPE_MAP.waxSeal],
    label: LABEL_BY_CARD_TYPE[CARD_TYPE_MAP.waxSeal],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: HAS_MOTIFS_BY_CARD_TYPE[CARD_TYPE_MAP.waxSeal],
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
  },
} as const;
